import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex, Box, Image, Text } from 'atoms';
import rejectedIcon from 'assets/rejected-icon.svg';

export default function RejectionList({ invoices = [], isModel = false }) {
	return (
		<Container isModel={isModel}>
			<Text fontSize="14px" lineheight="19px" my=".75rem" fontWeight="500">
				Rejection Message
			</Text>
			{invoices?.map((item) => (
				<Box key={item?.id} mb="0.75rem">
					{item?.invoice_verification_status === 'RejectedBySegregator' && (
						<Flex alignItems="center" mb="0.25rem">
							<Image src={rejectedIcon} alt="rejectedIcon" height={16} width={16} />
							<InvoiceNumber>{item?.invoice_no}</InvoiceNumber>
						</Flex>
					)}
					{item?.rejectNotification?.map((remark) => (
						<Flex key={remark?.id} flexDirection="column">
							{item?.invoice_verification_status === 'RejectedByCashier' && (
								<Flex alignItems="center">
									<Image
										src={rejectedIcon}
										alt="rejectedIcon"
										height={16}
										width={16}
									/>
									<InvoiceNumber>
										<span>
											{remark?.payment_type
												? remark?.payment_type
												: item?.invoice_no}
										</span>
										<span>
											{remark?.reference_number
												? `: ${remark?.reference_number}`
												: ''}
										</span>
									</InvoiceNumber>
								</Flex>
							)}
							<Remark key={remark?.id}>{remark?.remark}</Remark>
						</Flex>
					))}
				</Box>
			))}
		</Container>
	);
}

const Container = styled(Flex)`
	padding: 0.5rem 1rem;
	margin-bottom: 0.5rem;
	flex-direction: column;
	overflow: auto;
	max-height: ${(props) => (props.isModel ? 'unset' : '100px')};
	background-color: ${(props) =>
		props.isModel ? props.theme.colors.white : props.theme.colors.Snow};
`;

const InvoiceNumber = styled(Box)`
	padding-left: 0.5rem;
	font-size: 12px;
	color: ${(props) => props.theme.colors.TartOrange};
	margin: 0.5rem 0;
`;

const Remark = styled(Box)`
	margin-bottom: 0.5rem;
	padding-left: 1.5rem;
	font-size: 12px;
`;

RejectionList.propTypes = {
	invoices: PropTypes.array,
	isModel: PropTypes.bool,
};
